<app-impersonate-organisation
  [organisationId]="supplierId"
  [showDialog]="showImpersonateDialog"
  (onClose)="onImpersonateClose()"
>
</app-impersonate-organisation>

<div class="profile-header">
  <div class="flex-grow-1 content-header" style="align-content: space-evenly">Supplier Profile</div>
  <div class="flex-shrink-1">
    <p-button
      pButton
      label="Impersonate Supplier"
      (click)="impersonateSupplier()"
      [disabled]="isImpersonating"
    ></p-button>
  </div>
</div>

<div class="container-secondary d-grid grid-gap-15">
  <div *ngIf="loadingData" class="grid">
    <div class="w-100 p-5 text-center">
      <i class="fa fa-spinner fa-spin fa-2x"></i> Loading Supplier Information...
    </div>
  </div>

  <div class="supplier-area content-section flex-grow-1" *ngIf="!loadingData">
    <div class="flex flex-wrap grid-gap-15">
      <div class="camera-box">
        <div
          *ngIf="supplierInfo?.defaultProfileImageUrl; else noImage"
          class="image"
          [style.backgroundImage]="'url(' + supplierInfo.defaultProfileImageUrl + ')'"
        ></div>
        <ng-template #noImage>
          <span class="grey-circle">
            <i class="fa fa-camera"></i>
          </span>
        </ng-template>
      </div>

      <div class="flex-grow-1 supplier-details">
        <div class="supplier-region">
          <table style="width: 100%">
            <tr>
              <td>
                <div>
                  <span class="content-header">
                    {{ supplierInfo?.supplierName }}
                    {{ supplierInfo?.contactName }}
                  </span>
                </div>
              </td>
              <td
                *ngIf="supplierIsDND"
                style="font-size: 12px; text-align: right; white-space: nowrap; color: #e0284f"
              >
                <span> <i class="fa fa-minus-circle"></i>&nbsp;Do Not Disturb </span>
              </td>
              <td style="text-align: right; white-space: nowrap; width: 10px">
                <span *ngIf="supplierInfo?.inactive" class="inactive-state">
                  <span class="state-wrapper inactive-ball"></span> deactivated
                </span>
                <span *ngIf="supplierInfo?.suspended" class="suspended-state">
                  <span class="state-wrapper suspended-ball"></span> suspended
                </span>
                <span
                  *ngIf="!supplierInfo?.inactive && !supplierInfo?.suspended"
                  class="active-state"
                >
                  <span class="state-wrapper active-ball"></span> activated
                </span>
              </td>
            </tr>
          </table>
          <div class="contract-type mb-2">{{ supplierInfo?.organisationContractType?.name }}</div>

          <div class="mb-2">
            <span style="font-size: 14px; font-weight: bold">Contact details</span>
            <span class="edit-contact link-style" (click)="initEditContactDetails()"
              >edit <i class="fa fa-pencil"></i
            ></span>
          </div>

          <table style="width: 100%">
            <tr>
              <td class="supplier-data-small mb-1">
                <span class="icon-set"><i class="fa fa-phone"></i></span>
              </td>
              <td class="supplier-data-value">
                <ng-container *ngIf="phoneNumberList?.length; else noPhones">
                  <ng-container *ngFor="let phone of phoneNumberList; let last = last">
                    <a [attr.href]="toTelHref(phone)">{{ phone }}</a
                    ><span *ngIf="!last"> | </span>
                  </ng-container>
                </ng-container>

                <ng-template #noPhones>
                  <span class="text-muted">—</span>
                </ng-template>
              </td>
            </tr>
            <tr>
              <td class="supplier-data-small mb-1">
                <span class="icon-set"><i class="fa fa-envelope"></i></span>
              </td>
              <td class="supplier-data-value">
                <a class="link-style" href="mailto: {{ supplierInfo?.emailAddress }}">{{
                  supplierInfo?.emailAddress
                }}</a>
              </td>
            </tr>
            <tr>
              <td class="supplier-data-small mb-1">
                <span class="icon-set"><i class="fa fa-home"></i></span>
              </td>
              <td class="supplier-data-value">{{ supplierInfo?.address }}</td>
            </tr>
            <tr>
              <td class="supplier-data-small mb-1">
                <span class="icon-set"><i class="fa fa-map-marker"></i></span>
              </td>
              <td class="supplier-data-value">
                Zone: {{ supplierInfo?.zoneName || 'N/A' }} | Area:
                {{ supplierInfo?.areaName || 'N/A' }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="content-section" *ngIf="!loadingData">
    <div class="flex flex-wrap grid-gap-15 w-100" style="margin-bottom: 16px">
      <div class="flex-grow-1 text-left">
        <span class="content-header">Activity</span>
      </div>
      <div class="flex-grow-1 text-right">
        <span class="feint-text small-text">Latest Job:</span>
        <span class="feint-text small-text">
          {{
            supplierInfo?.supplierOperationalData?.lastCompletedTaskDate | datex : 'ddd DD MMM yyyy'
          }}
        </span>
      </div>
    </div>

    <div class="ui-grid-row">
      <div class="ui-g-nopad">
        <div class="supplier-information-grid-container">
          <div style="margin-right: 36px">
            <div class="feint-text">Total jobs</div>
            <div class="job-count">{{ supplierInfo?.supplierOperationalData?.totalJobs }}</div>
          </div>
          <div style="display: flex; flex-wrap: wrap; flex-grow: 1">
            <div style="margin-right: 24px">
              <div>
                <div class="ui-g-nopad">
                  <span class="no-padding feint-text">Joined:</span>
                  <span class="no-padding activity-value">
                    {{ supplierInfo?.dateCreated | date : 'dd MMM YYY' }}
                  </span>
                </div>
              </div>
              <div>
                <div class="ui-g-nopad" style="margin-top: 10px">
                  <span class="no-padding feint-text">Jobs Completed: </span
                  ><span class="no-padding activity-value"
                    >{{ supplierInfo?.supplierOperationalData?.completionRateLast30Days }}%</span
                  >
                </div>
              </div>
              <div>
                <div class="ui-g-nopad" style="margin-top: 10px">
                  <span class="no-padding feint-text">Jobs in last 90 days: </span
                  ><span class="no-padding activity-value"
                    >{{ supplierInfo?.supplierOperationalData?.jobsInLast90Days }} Jobs</span
                  >
                </div>
              </div>
            </div>
            <div>
              <div>
                <span class="feint-text">Classification: </span>
                <app-supplier-classification
                  [supplierOperationalData]="supplierInfo?.supplierOperationalData"
                ></app-supplier-classification>
              </div>
              <div>
                <div class="ui-g-nopad" style="margin-top: 10px">
                  <span class="no-padding feint-text">Jobs in last 30 days: </span
                  ><span class="no-padding activity-value"
                    >{{ supplierInfo?.supplierOperationalData?.jobsInLast30Days }} Jobs</span
                  >
                </div>
              </div>
              <div>
                <div class="ui-g-nopad" style="margin-top: 10px">
                  <span class="no-padding feint-text">Jobs in last 180 days: </span
                  ><span class="no-padding activity-value"
                    >{{ supplierInfo?.supplierOperationalData?.jobsInLast180Days }} Jobs</span
                  >
                </div>
              </div>
            </div>
            <div class="carry-over-status">
              <div class="feint-text">Carry over status:</div>
              <div
                class="activity-value"
                [ngClass]="{
                  'carry-over-restricted': supplierInfo?.restrictCarryover,
                  'carry-over-allowed': !supplierInfo?.restrictCarryover
                }"
              >
                {{
                  supplierInfo?.restrictCarryover ? 'No carry over allowed' : 'Carry over allowed'
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap mt-2">
      <table style="margin-top: 24px">
        <tr>
          <td>Tags:</td>
          <td>
            <span
              *ngFor="let tag of supplierInfo?.tagEntities"
              [pTooltip]="tag?.description"
              class="tag-wrapper"
            >
              <span class="tag"><i class="las la-tag fa-flip-horizontal"></i> {{ tag.name }}</span
              >&nbsp;</span
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>

<div class="data-container">
  <div *ngIf="loadingData" class="grid">
    <div class="col-12" style="text-align: center; margin-top: 20px">
      <i class="fa fa-spinner fa-spin fa-2x"></i> Loading Supplier Information...
    </div>
  </div>

  <div *ngIf="!loadingData" class="supplier-information-grid">
    <!-- TABS -->
    <div
      *ngIf="supplierInfo"
      class="ui-grid-row ui-grid-responsive mb-3"
      style="border: 1px solid var(--container-border-color); border-radius: 10px"
    >
      <div class="ui-grid-col-12" style="height: 100%">
        <p-tabView
          #tabviewMain
          class="no-padding-tabview"
          [style]="{ height: '100%', 'border-radius': '10px', 'overflow-x': 'hidden' }"
          [(activeIndex)]="activeIndex"
        >
          <p-tabPanel class="no-rounded-top-tabview" header="All Jobs">
            <supplier-profile-all-jobs></supplier-profile-all-jobs>
          </p-tabPanel>
          <p-tabPanel class="no-rounded-top-tabview" header="Current Jobs">
            <!-- Live Job(s) -->
            <jobs-information-list
              [homePosition]="supplierHomePos"
              [jobs]="liveJobs"
              [latestPosition]="supplierInfo.latestPosition"
              [subWord]="'current'"
              [busy]="loadingData"
            ></jobs-information-list>
          </p-tabPanel>
          <p-tabPanel class="no-rounded-top-tabview" header="Upcoming Jobs">
            <jobs-information-list
              [homePosition]="supplierHomePos"
              [jobs]="upcomingJobs"
              [subWord]="'upcoming'"
              [busy]="loadingData"
            ></jobs-information-list>
          </p-tabPanel>
          <p-tabPanel class="no-rounded-top-tabview" header="Closed/Cancelled Jobs">
            <ng-template pTemplate="content">
              <supplier-closed-jobs
                [impersonating]="impersonating"
                [supplierHomePos]="supplierHomePos"
                [supplierId]="supplierInfo.id"
              ></supplier-closed-jobs>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel class="no-rounded-top-tabview" header="Watched Jobs">
            <ng-template pTemplate="content">
              <supplier-watched-jobs
                [impersonating]="impersonating"
                [noCallLink]="true"
                [supplierHomePos]="supplierHomePos"
                [supplierId]="supplierInfo.id"
              ></supplier-watched-jobs>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel
            *ngIf="!impersonating"
            class="no-rounded-top-tabview"
            header="Additional Costs"
          >
            <ng-template pTemplate="content">
              <supplier-charges-information
                [status]="1"
                [supplierId]="supplierInfo.id"
              ></supplier-charges-information>
            </ng-template>
          </p-tabPanel>
        </p-tabView>

        <!-- navigating to job screen -->
        <div
          *ngIf="loadingJobScreen"
          style="
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 1000;
            height: 100%;
            background-color: rgba(51, 51, 51, 0.75);
          "
        >
          <div class="flex align-items-center justify-content-center" style="height: 100%">
            <div style="width: 80px; margin: 0 auto; top: 45%; position: relative">
              <i class="fa fa-spinner fa-4x fa-spin" style="color: white"></i>
            </div>
          </div>
          <!--        <i class="fa fa-spinner fa-4x fa-spin" style="position: relative; left: 50%; top: 50%; color: white;">&nbsp;</i>-->
        </div>
      </div>
    </div>

    <!-- Weekly schedule -->
    <app-weekly-calendar
      [supplierId]="supplierId"
      (onSupplierTodayDNDChanged)="handleSupplierTodayDNDChanged($event)"
    ></app-weekly-calendar>

    <!-- Two info boxes -->
    <div *ngIf="supplierInfo">
      <div class="info-box">
        <div>
          <div class="widget-container" style="padding-top: 10px">
            <div><h2 class="sub-header-bar">Calls</h2></div>

            <div class="call-table-wrapper">
              <table *ngIf="supplierInfo?.recentCalls" class="call-table w-100 table-striped">
                <thead>
                  <tr>
                    <th>Direction</th>
                    <th>Date & Time</th>
                    <th>Reponse</th>
                    <th>Operator</th>
                    <th>Duration</th>
                    <th>Reason</th>
                    <th>Associated Job(s)</th>
                    <th>AI Summary</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let call of supplierInfo.recentCalls">
                    <td>{{ call.outboundCall ? 'Outbound' : 'Inbound' }}</td>
                    <td>{{ call.created | date : 'EEE dd MMM HH:mm' }}</td>
                    <td>{{ call.statName }}</td>
                    <td>{{ call.operatorName }}</td>
                    <td>{{ call.durationText }}</td>
                    <td>{{ call.wrapUpReason || call.disposition }}</td>
                    <td>
                      <div *ngFor="let jobInfo of call.associatedJobInfos">
                        <a href="/app/jobscreen/{{ jobInfo.jobId }}" target="_blank">{{
                          jobInfo.jobNumber
                        }}</a>
                      </div>
                    </td>
                    <td
                      style="cursor: pointer"
                      (click)="toggleAISummary(call)"
                      pTooltip="This feature is not yet available in Dialpad"
                    >
                      View
                      <span *ngIf="!call.summaryShowing"><i class="fa fa-caret-down"></i></span>
                      <span *ngIf="call.summaryShowing"><i class="fa fa-caret-up"></i></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="info-box">
        <div class="mb-3">
          <interactions [organisationId]="supplierId"></interactions>
        </div>
      </div>

      <!--      <div class="flex-grow-1 info-box">-->
      <!--        <div class="widget-container" style="padding-top: 10px">-->
      <!--          <div><h2 class="sub-header-bar">Supplier Feedback</h2></div>-->

      <!--          <div class="call-table-wrapper">-->
      <!--            <div *ngIf="loadingFeedback" class="center-block">-->
      <!--              <i class="fa fa-spinner fa-spin"></i> Loading...-->
      <!--            </div>-->

      <!--            <table-->
      <!--              *ngIf="!loadingFeedback && supplierFeedback"-->
      <!--              class="call-table table-striped w-100"-->
      <!--            >-->
      <!--              <thead>-->
      <!--                <tr>-->
      <!--                  <th>Job</th>-->
      <!--                  <th>Date</th>-->
      <!--                  <th>Customer</th>-->
      <!--                  <th>Feedback</th>-->
      <!--                  <th>Outcome</th>-->
      <!--                </tr>-->
      <!--              </thead>-->
      <!--              <tbody>-->
      <!--                <tr *ngFor="let feedback of supplierFeedback">-->
      <!--                  <td>{{ feedback.jobNumber }}</td>-->
      <!--                  <td>{{ feedback.createdOn | date : 'EEE dd MMM HH:mm' }}</td>-->
      <!--                  <td>{{ feedback.customerName }}</td>-->
      <!--                  <td>{{ feedback.supplierFeedbackType.description }}</td>-->
      <!--                  <td>{{ feedback.outcomeDescription || 'not resolved' }}</td>-->
      <!--                </tr>-->
      <!--              </tbody>-->
      <!--            </table>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showEditContactDetails"
  [modal]="true"
  [responsive]="true"
  [style]="{ width: '800px' }"
  [closable]="false"
>
  <form [formGroup]="editForm">
    <div class="flex flex-wrap grid-gap-35">
      <div class="camera-box">
        <div
          *ngIf="supplierInfo?.defaultProfileImageUrl; else noImage"
          class="image"
          [style.backgroundImage]="'url(' + supplierInfo.defaultProfileImageUrl + ')'"
        ></div>
        <ng-template #noImage>
          <span class="grey-circle">
            <i class="fa fa-camera"></i>
          </span>
        </ng-template>
      </div>

      <div class="flex-grow-1 supplier-details">
        <h2>Edit Contact Details</h2>

        <input type="hidden" name="id" formControlName="id" />
        <input type="hidden" name="phoneNumber" formControlName="phoneNumber" />

        <div class="flex flex-wrap grid-gap-35 mb-3 mt-3">
          <div class="edit-label">Phone Numbers:</div>

          <div class="flex-grow-1">
            <div *ngIf="supplierInfo?.telephone">
              {{ supplierInfo.telephone }}
              <span style="font-size: 0.8em; margin-left: 5px; vertical-align: top">(Primary)</span>
            </div>

            <span class="add-number link-style small-text text-right" (click)="addNewPhone()">
              + Add Number
            </span>

            <div formArrayName="phoneNumbers">
              <div *ngFor="let item of phoneNumbers.controls; let index = index">
                <div [formGroupName]="index" class="edit-value mb-2" style="position: relative">
                  <input
                    pInputText
                    formControlName="telephone"
                    placeholder="Input number"
                    style="width: 100%"
                    (blur)="onPhoneNumberAdded(index, $event)"
                  />
                  <input type="hidden" formControlName="id" />
                  <span
                    class="add-number link-style small-text text-right"
                    (click)="deletePhone(index)"
                  >
                    Delete
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap grid-gap-35 mb-3">
          <div class="edit-label">E-mail:</div>
          <div class="edit-value">
            <input pInputText formControlName="emailAddress" style="width: 100%" />
          </div>
        </div>

        <div class="flex flex-wrap grid-gap-35 mb-3">
          <div class="edit-label">Address 1:</div>
          <div class="edit-value">
            <input pInputText formControlName="addressLine1" style="width: 100%" />
          </div>
        </div>

        <div class="flex flex-wrap grid-gap-35 mb-3">
          <div class="edit-label">Address 2:</div>
          <div class="edit-value">
            <input pInputText formControlName="addressLine2" style="width: 100%" />
          </div>
        </div>

        <div class="flex flex-wrap grid-gap-35 mb-3">
          <div class="edit-label">Address 3:</div>
          <div class="edit-value">
            <input pInputText formControlName="addressLine3" style="width: 100%" />
          </div>
        </div>

        <div class="flex flex-wrap grid-gap-35 mb-3">
          <div class="edit-label">Town:</div>
          <div class="edit-value">
            <input pInputText formControlName="town" style="width: 100%" />
          </div>
        </div>

        <div class="flex flex-wrap grid-gap-35 mb-3">
          <div class="edit-label">City:</div>
          <div class="edit-value">
            <input pInputText formControlName="city" style="width: 100%" />
          </div>
        </div>

        <div class="flex flex-wrap grid-gap-35 mb-3">
          <div class="edit-label">Postcode:</div>
          <div class="edit-value">
            <input pInputText formControlName="postcode" style="width: 100px" />
          </div>
        </div>
      </div>
    </div>

    <div class="text-right">
      <button
        class="ui-button-secondary"
        pButton
        label="Cancel"
        data-action="cancel"
        (click)="closeDialogWithoutSave()"
      ></button>
      <button
        class="ui-button-primary"
        pButton
        icon="fa fa-check"
        label="Save"
        (click)="saveEditForm()"
      ></button>
    </div>
  </form>
</p-dialog>
